<div class="chart">
  <div #pieChartContainer class="svg-pie-chart"></div>
  <div class="legend" *ngIf="data?.length">
    <div class="legend-row" *ngFor="let d of data">
      <span class="dot" [style.background]="d.color"></span>
      <span class="legend-name" [attr.title]="d.name">{{ d.name }}</span>
    </div>
  </div>
</div>